import React from "react";
import Layout from "../../Layouts/Layout";
import ServiceWorldCase from "../../../components/Serviceworld/ServiceWorldCase";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

const ServiceWorldCasePage = () => {
  return (
    <LayoutAuthenticated>
      <ServiceWorldCase />
    </LayoutAuthenticated>
  );
};

export default ServiceWorldCasePage;
